import { FC, useState } from 'react';
import { Button, Code, Flyout } from '@lithos';

const ViewDefinitionFlyout: FC<{ type: any; definition: any }> = ({ type, definition }) => {
  const [isFlyoutOpen, setIsFlyoutOpen] = useState<boolean>(false);

  return (
    <>
      <Button
        onClick={() => {
          setIsFlyoutOpen(true);
        }}
        icon="Code"
        label="View Definition"
        type="ghost"
      />
      {isFlyoutOpen && (
        <Flyout
          title={type}
          isOpen={isFlyoutOpen}
          setIsOpen={() => {
            setIsFlyoutOpen(!isFlyoutOpen);
          }}
          content={<Code code={definition.toString()} />}
        />
      )}
    </>
  );
};

export default ViewDefinitionFlyout;
